
<template>
    <!--T恤尺码-->
    <div id="sweaterApp">
        <div class="sweater-dialog-mask"></div>
        <div id="sweater-wrap" class="sweater-sku-wrap">
            <div class="header">
                <div class="sweater-img-wrap">
                    <img class="j-summary-img" aria-label="选中的商品图" :src="imageUrl">
                </div>
                <div class="sweater-main">
                    <div class="price-wrap">
                        <span class="sweater-price">¥{{price}}</span>  
                    </div>   
                    <div class="stock">库存{{sweaterCount}}件</div>   
                    <div class="sku-info" id="message"><span>已选蓝色{{chooseSize}}</span></div>
                </div>
                <a class="sweater-sku-close" aria-label="关闭" @click="close()"></a>
            </div>
            <div class="sweater-body">
                <div class="sweater-body-item" >
                    <ul class="sweater-sku-list-wrap">
                        <li>
                            <h2 id="sweater-title1">颜色分类</h2>
                            <div class="sweater-items"> 
                                <a role="radio" href="javascript:void(0)"  aria-checked="true" class="checked">蓝色</a> 
                            </div>
                        </li>
                        <li>
                            <h2 id="sweater-title2">尺码</h2>
                            <div class="sweater-items"> 
                                <a role="radio" href="javascript:void(0)"  aria-checked="true" v-for="(item,index) in sweaterSize" :key="item.size" :class="{'checked':index==curIndex}" @click="curIndex=index, changeSize(index)">{{item.size}}</a> 
                            </div>
                        </li>
                    </ul>
                    <div class="sweater-number-wrap">
                        <div class="sweater-number-line">
                            <label for="number">购买数量</label>
                            <div class="sweater-number">
                                <button id="sweaterIncrease" class="decrease disabled" @click="changeCount(-1)">-</button>
                                <input id="number" type="number" v-model="productNum">
                                <button id="decrease" class="sweaterIncrease" @click="changeCount(1)">+</button>
                            </div>
                        </div>
                    </div>
                    <p v-show="overstock" class="sweater-warn">您所填写的商品数量超过库存！</p>
                </div>
            </div>
            <div class="footer trade">
                <a class='sweater-confirm' :class="[overstock ? 'disabled' : '']" role="button" @click="sendOrder()">确定</a>
            </div>
            <div id="sweaterPoints"><span id="sweaterPointMess"></span></div>
        </div>     
    </div> 

</template>

<script>
export default {
    data(){
        return{
            imageUrl:'http://m.artgogo.com/images/2018/12/29/1546089411eragyph73_a.jpg',
            price:666,
            sweaterCount:0,
            overstock:false,
            productNum:1,
            chooseSize:'',
            curIndex: -1,
            sweaterSize:[{
              size: "165/S",
              sizeQuantity: 30
            },
            {
              size: "170/M",
              sizeQuantity: 100
            },
            {
              size: "175/L",
              sizeQuantity: 70
            }]
        }
    },
    mounted:function(){
        this.$nextTick(function(){
            this.init()
        })
    },
    watch:{
        productNum:function(){
            if(this.productNum > this.sweaterCount){
                this.overstock = true
            }else{
                this.overstock = false
            }
            if(this.productNum > 1){
                document.getElementById("sweaterIncrease").classList.remove("disabled")
            }
            if(this.productNum < 2){
                document.getElementById("sweaterIncrease").classList.add("disabled")
                this.productNum = 1
            }
        },
        sweaterCount:function(){
            if(this.productNum > this.sweaterCount){
                this.overstock = true
            }else{
                this.overstock = false
            }
        }
    },
    methods:{
        init:function(){
            var datas = this.sweaterSize
            for(var i = 0; i< datas.length; i++){
                this.sweaterCount+=datas[i].sizeQuantity
            }
        },
        changeSize:function(index){
            this.chooseSize = this.sweaterSize[index].size
            this.sweaterCount = this.sweaterSize[index].sizeQuantity
        },
        changeCount:function(num){
            if(num > 0){
                this.productNum++              
            }else{
                this.productNum--
            }
        },
        close: function() {
            document.getElementById("sweaterApp").classList.remove("show-up");
        },
        
        maskShow: function(mess) {
            var timeDialog = "";
            clearTimeout(timeDialog);
            timeDialog = setTimeout(function() {
                document.getElementById("sweaterPointMess").innerHTML = mess;
                document.getElementById("sweaterPoints").style.display = "block";
                setTimeout(function() {
                document.getElementById("sweaterPoints").style.display = "none";
                }, 1500);
            }, 100);
        },
        sendOrder:function(){
            if(this.overstock == true && this.chooseSize != ''){
                return
            }
            if(this.overstock == false && this.chooseSize == ''){       
                this.maskShow('请选择尺码')
                return 
            }
            window.location.href ="/newwap/new_wap/php/wap_confirm_order.php?art_id=137445&blackSize=" +encodeURI(this.chooseSize)+"&count=" +encodeURI(this.productNum)
        }
    }
}
</script>

<style lang="scss" scoped>


@charset "utf-8";
html {
  font-size: 100px;
}

@media (min-width: 320px) {
  html {
    font-size: 100px;
  }
}

@media (min-width: 360px) {
  html {
    font-size: 112.5px;
  }
}

@media (min-width: 400px) {
  html {
    font-size: 125px;
  }
}

@media (min-width: 640px) {
  html {
    font-size: 200px;
  }
}

body {
  background: #fff;
  font-size: 0.12rem;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
  height: 0;
}

html,
body,
form,
img,
ul,
ol,
li,
dl,
dt,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
b,
u,
i,
p,
em,
td,
th,
input,
textarea,
select,
iframe {
  font-family: "黑体", Arial, "simsun";
  /*font-family:"simsun";*/

  color: #191919;
  padding: 0;
  margin: 0;
  font-style: normal;
}

html* {
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
  font-size: 0.06rem;
  vertical-align: middle;
}

input {
  outline: 0;
  border-radius: 0;
  -webkit-appearance: none;
  appearance: none;
  border: none;
}

td {
  font-family: Arial;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

ul li {
  vertical-align: bottom;
  padding: 0;
  margin: 0;
}

em i {
  font-style: normal;
}

li {
  list-style: none;
}

ol {
  list-style-type: none;
  list-style: none;
}

dd {
  margin-left: 0;
}

a img {
  border: 0;
}

h1 {
  font-size: 0.1rem;
}

h2,
h3 {
  font-size: 0.07rem;
  font-family: "黑体";
}

h4,
h5,
h6 {
  font-size: 0.06rem;
}

a {
  color: #191919;
  text-decoration: none;
  outline: 0;
}

a:active {
  text-decoration: none;
}

a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

/*首页头部*/
body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}

#sweaterApp  {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
}
#sweater-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 20%;
  z-index: 2002;
  background: #fff;
  -webkit-transform: translate3d(0, 105%, 0);
  transform: translate3d(0, 105%, 0);
  transition: all 300ms ease; 
}
.sweater-dialog-mask {
  z-index: 2001;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0;
  transition: all 300ms ease;
}

#sweaterApp.show-up {
  z-index: 2000;
}
#sweaterApp.show-up #sweater-wrap {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
#sweaterApp.show-up .sweater-dialog-mask {
  opacity: 0.5;
}
#sweater-wrap .header {
  position: relative;
  padding: 0.05rem 0.05rem 0.05rem 1.15rem;
  height: 8rem;
}
#sweater-wrap .header .sweater-img-wrap {
  width: 0.9rem;
  height: 0.9rem;
  position: absolute;
  top: -0.2rem;
  left: 0.1rem;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1px;
  background-color: #fff;
}
#sweater-wrap .sweater-img-wrap img {
  width: 100%;
}
#sweater-wrap .header .sweater-main {
  color: #051b28;
  font-size: 12px;
  line-height: 18px;
  padding-right: 10px;
  font-family: "微软雅黑";
  position: absolute;
  left: 1.1rem;
  top:.1rem;
}
.sweater-sku-wrap .header .sweater-main .sweater-price {
  font-family: arial;
  font-size: 16px;
  word-wrap: break-word;
}
.sweater-sku-wrap .header .sweater-sku-close {
  position: absolute;
  top:0.1rem;
  right: 20px;
}
.sweater-sku-wrap .header .sweater-sku-close:after {
  content: "×";
  display: block;
  width: 20px;
  height: 20px;
  border: 1px solid #5f646e;
  border-radius: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 18px;
  color: #5f646e;
  position: absolute;
  right: 3px;
  top: 5px;
  font-size: 20px;
}
#message span {
  color: #fbc400;
}
.sweater-sku-wrap .sweater-body {
  padding: 0 15px 10px;
  position: absolute;
  bottom: 48px;
  top: 105px;
  left: 0;
  right: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.sweater-sku-wrap .sweater-body:before,
.signature:before {
  content: "";
  display: block;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.bundle-wrap li,
.sweater-sku-list-wrap li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 10px;
}
.sweater-sku-wrap .sweater-body h2 {
  color: #666;
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 10px;
  padding-top: 10px;
}
.bundle-wrap .sweater-items .checked,
.sweater-sku-list-wrap .sweater-items .checked {
  border-color: #fbc400;
  background: rgba(251, 196, 0, 0.1);
}
.bundle-wrap .sweater-items .disabled,
.sweater-sku-list-wrap .sweater-items .disabled {
  color: #cfcfcf;
  pointer-events: none;
}

.bundle-wrap .sweater-items a,
.sweater-sku-list-wrap .sweater-items a {
  position: relative;
  display: inline-block;
  border: 1px solid #f5f5f5;
  background-color: #f5f5f5;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  margin: 0 8px 8px 0;
  color: #555;
}
.sweater-number-wrap .sweater-number-line {
  padding-bottom: 10px;
  padding-top: 10px;
  line-height: 36px;
}
.sweater-number-wrap label {
  color: #666;
  font-size: 14px;
  font-weight: 400;
}
.sweater-number-wrap .sweater-number {
  height: 36px;
  width: 100px;
  border-radius: 3px;
  float: right;
}
.sweater-number-wrap .sweater-number .decrease {
  border-right: 1px solid #fff;
}

.sweater-number-wrap .sweater-number button {
  border: none;
  outline: 0;
  line-height: 32px;
  height: 34px;
  width: 30px;
  font-size: 24px;
  border: 1px solid #f5f5f5;
  background-color: #f5f5f5;
  padding: 0;
  color: #191919;
}
.sweater-number-wrap .sweater-number button,
.sweater-number-wrap .sweater-number input[type="number"] {
  float: left;
}
.sweater-number-wrap .sweater-number input[type="number"] {
  line-height: 32px;
  height: 34px;
  width: 36px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  border: 1px solid #f5f5f5;
  background-color: #f5f5f5;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  margin: 0;
}
.sweater-number-wrap .sweater-number .sweaterIncrease {
  border-left: 1px solid #fff;
}
.sweater-number-wrap .sweater-number .disabled {
  color: #cfcfcf;
}
.sweater-sku-wrap .footer {
  display: block;
  display: -webkit-box;
  display: flex;
  height: 48px;
  text-align: center;
  line-height: 48px;
  color: #fff;
  width: 100%;
  position: absolute;
  bottom: 0;
}
.sweater-sku-wrap .footer .sweater-confirm {
  display: block;
  font-size: 15px;
  line-height: 50px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #fff;
  background: -webkit-linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: -o-linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: -moz-linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
  background: linear-gradient(
    to right,
    rgba(244, 218, 123, 1),
    rgba(251, 197, 3, 1)
  );
}
.sweater-sku-wrap .footer .sweater-confirm.disabled{
    background:#ccc;
}
#sweaterPoints {
  display: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  margin: auto;
}
#sweaterPointMess {
  padding: 20px 20px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  border-radius: 6px;
}
.sweater-warn{
    text-align: right;
    font-size: 12px;
    color: red;
}
</style>
